import {
  useV2ListQuestionnairesForAccountQuery,
  V2AccountResource,
  V2QuestionResource,
} from "@generated";
import { TakeSurveyType } from "../types";

const useListTakeSurveys = ({
  pageSize,
  pageNumber,
  filterParams,
  sortBy,
  sortOrder,
}) => {
  let customError: string | null = null; // Declare customError
  let pageMeta = {
    recordCount: 0,
    pageCount: 0,
  };

  const { data, error, isLoading, refetch, isFetching } =
    useV2ListQuestionnairesForAccountQuery({
      filter: {
        ...filterParams,
        published: true,
      },
      page: {
        number: pageNumber,
        size: pageSize,
      },
      include: ["account", "questions"],
      sort: sortBy
        ? [sortOrder == "asc" ? sortBy : `-${sortBy}`]
        : ["-created_at"],
    });

  let takeSurveys: TakeSurveyType[] = [];
  let included: (V2AccountResource | V2QuestionResource)[] = [];

  if (data?.data) {
    try {
      takeSurveys = data.data.map((questionnaire) => {
        if (!questionnaire.id) {
          throw new Error("Missing questionnaire.id");
        }
        if (!questionnaire?.attributes?.name) {
          throw new Error("Missing questionnaire.attributes.name");
        }

        return {
          id: String(questionnaire.id),
          type: "questionnaires",
          attributes: {
            ...questionnaire.attributes,
          },
        };
      });

      if (!data.meta) {
        throw new Error("Missing data.meta");
      }

      if (!data.meta["record-count"]) {
        throw new Error('Missing data.meta["record-count"]');
      }

      if (!data.meta["page-count"]) {
        throw new Error('Missing data.meta["page-count"]');
      }
      pageMeta = {
        recordCount: data.meta["record-count"],
        pageCount: data.meta["page-count"],
      };
      //@ts-ignore
      included = data?.included || [];
    } catch (err) {
      if (err instanceof Error) {
        customError = err.message;
      } else {
        customError = "An unknown error occurred";
      }
    }
  }
  return {
    takeSurveys,
    isLoading,
    included,
    error: error ?? customError,
    pageMeta,
    refetch,
    isFetching,
  };
};
export default useListTakeSurveys;
